import { Component, OnInit } from '@angular/core';
import { InsurerPremiumChartHandler } from './insurer-premium-chart.handler.';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'sym-insurer-premium-chart',
  templateUrl: './insurer-premium-chart.component.html',
  styleUrls: ['./insurer-premium-chart.component.scss'],
})
export class InsurerPremiumChartComponent extends InsurerPremiumChartHandler {
  constructor(
    public service: DashboardService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, headerService, router, settingService, offlineService);
  }
}
